/**
 * @generated SignedSource<<fba0951a0da687355e3973be889f38c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReferencesTab_ReferencesQuery$variables = {
  userId: string;
};
export type ReferencesTab_ReferencesQuery$data = {
  readonly user: {
    readonly references?: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ReferenceCard_Reference">;
    }> | null | undefined;
  } | null | undefined;
};
export type ReferencesTab_ReferencesQuery = {
  response: ReferencesTab_ReferencesQuery$data;
  variables: ReferencesTab_ReferencesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "userId"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "status",
    "value": "completed"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReferencesTab_ReferencesQuery",
    "selections": [
      {
        "alias": "user",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "Reference",
                "kind": "LinkedField",
                "name": "references",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReferenceCard_Reference"
                  }
                ],
                "storageKey": "references(status:\"completed\")"
              }
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReferencesTab_ReferencesQuery",
    "selections": [
      {
        "alias": "user",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "Reference",
                "kind": "LinkedField",
                "name": "references",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "comments",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ratingOverall",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ratingProfessional",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ratingExpert",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "relation",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "otherRelation",
                    "storageKey": null
                  }
                ],
                "storageKey": "references(status:\"completed\")"
              }
            ],
            "type": "User",
            "abstractKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5280c86d93d11f00f80789ccb11b7b52",
    "id": null,
    "metadata": {},
    "name": "ReferencesTab_ReferencesQuery",
    "operationKind": "query",
    "text": "query ReferencesTab_ReferencesQuery(\n  $userId: ID!\n) {\n  user: node(id: $userId) {\n    __typename\n    ... on User {\n      references(status: completed) {\n        id\n        ...ReferenceCard_Reference\n      }\n    }\n    id\n  }\n}\n\nfragment ReferenceCard_Reference on Reference {\n  name\n  comments\n  ratingOverall\n  ratingProfessional\n  ratingExpert\n  relation\n  otherRelation\n}\n"
  }
};
})();

(node as any).hash = "e738eeefb118518adf988e481c94cb35";

export default node;
